import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { UserDetails } from '../models/UserDetails';
import { environment } from '../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { HandleError, HttpErrorHandler } from '../../../shared/service/error.service';

@Injectable({
  providedIn: 'root'
})
export class EditPersonalDataService {

  private readonly errorHandler: HandleError;

  constructor(private http: HttpClient, private httpErrorHandler: HttpErrorHandler) {
    this.errorHandler = httpErrorHandler.createHandleError('EditPersonalDataService');
    // toDo init countyList
    // toDo init cityList
  }

  getPersonalInfo(): Observable<UserDetails> {
    return this.http.get<UserDetails>(environment.loggedInUrl + '/info')
      .pipe(
        catchError(this.errorHandler('getPersonalInfo', null))
      );
  }

  getPersonalData(): Observable<UserDetails> {
    return this.http.get<UserDetails>(environment.loggedInUrl + '/detalii-utilizator')
      .pipe(
        catchError(this.errorHandler('getUserData', null))
      );
  }

  updatePersonalData(formData: FormData) {
    return this.http.put(environment.loggedInUrl + '/detalii-utilizator', formData);
  }
}
